/**
 * Build-provenance badge for the support console header.
 *
 * `__BUILD_COMMIT__` / `__BUILD_TIME__` are injected at build time by
 * Vite's `define` (see vite.config.ts): the short commit SHA the bundle
 * was built from, plus the build instant. Surfacing them lets staff tell
 * at a glance which build they're looking at — the difference between a
 * fresh deploy and a stale tab/dev server that a cache clear won't fix.
 *
 * The SHA is the visible text (compact); the full build time rides along
 * as the hover tooltip so the header stays uncluttered.
 */
export function BuildBadge() {
  const built = new Date(__BUILD_TIME__);
  const builtLabel = Number.isNaN(built.getTime())
    ? __BUILD_TIME__
    : built.toLocaleString();
  return (
    <span
      className="font-mono text-xs text-mute"
      title={`Build ${__BUILD_COMMIT__} · built ${builtLabel}`}
    >
      {__BUILD_COMMIT__}
    </span>
  );
}
